import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo/logo2.png'


const _hoisted_1 = { class: "site-shell" }
const _hoisted_2 = {
  id: "top",
  class: "hero-section"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "hero-inner" }
const _hoisted_5 = { class: "hero-copy" }
const _hoisted_6 = { class: "hero-proof" }
const _hoisted_7 = {
  class: "hero-dashboard",
  "aria-label": "项目交付能力看板"
}
const _hoisted_8 = { class: "signal-map" }
const _hoisted_9 = { class: "dashboard-metrics" }
const _hoisted_10 = { class: "impact-strip" }
const _hoisted_11 = { class: "strip-inner" }
const _hoisted_12 = {
  id: "services",
  class: "service-section"
}
const _hoisted_13 = { class: "service-grid" }
const _hoisted_14 = { class: "service-image" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "service-body" }
const _hoisted_17 = { class: "service-icon" }
const _hoisted_18 = { class: "tag-row" }
const _hoisted_19 = {
  id: "process",
  class: "process-section"
}
const _hoisted_20 = { class: "process-track" }
const _hoisted_21 = {
  id: "about",
  class: "about-section"
}
const _hoisted_22 = { class: "about-media" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "about-content" }
const _hoisted_25 = { class: "value-grid" }
const _hoisted_26 = {
  id: "advantages",
  class: "advantage-section"
}
const _hoisted_27 = { class: "advantage-grid" }
const _hoisted_28 = {
  id: "contact",
  class: "contact-section"
}
const _hoisted_29 = { class: "contact-copy" }
const _hoisted_30 = { class: "contact-list" }

import {reactive} from 'vue'
import {ElInput} from 'element-plus'
import heroBg from '@/assets/jpg/bg_ai.jpg'
import aboutImg from '@/assets/jpg/about.jpg'
import features1 from '@/assets/jpg/features1.jpg'
import features2 from '@/assets/jpg/features2.jpg'
import features3 from '@/assets/jpg/features3.jpg'


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const heroProof = [
  {value: '7天', label: '完成方案梳理'},
  {value: '全链路', label: '研发到运维覆盖'},
  {value: '长期', label: '持续迭代支持'}
]

const dashboardMetrics = [
  {label: '需求响应', value: '24h'},
  {label: '交付节奏', value: 'Sprint'},
  {label: '安全策略', value: 'On'}
]

const metrics = [
  {value: '1+', label: '成功项目'},
  {value: '100%', label: '客户满意度'},
  {value: '4', label: '技术专家'},
  {value: '2年', label: '行业经验'}
]

const features = [
  {
    title: '技术自主研发',
    description: '围绕 AI、大数据、云计算和业务系统开发，搭建能长期演进的核心技术能力。',
    image: features1,
    icon: 'fas fa-brain',
    tags: ['AI 应用', '数据中台', '云原生']
  },
  {
    title: '技术外包服务',
    description: '以可控成本获得稳定研发产能，覆盖需求、设计、开发、测试、部署和运维。',
    image: features2,
    icon: 'fas fa-rocket',
    tags: ['敏捷交付', '驻场协作', '质量保障']
  },
  {
    title: '定制化解决方案',
    description: '根据业务场景定制系统架构与产品功能，让技术投入直接服务增长和管理效率。',
    image: features3,
    icon: 'fas fa-layer-group',
    tags: ['软件开发', '系统集成', '技术咨询']
  }
]

const processSteps = [
  {no: '01', title: '需求分析', description: '拆解业务目标、用户路径和系统边界，先把方向定准。'},
  {no: '02', title: '方案设计', description: '输出技术架构、阶段计划和风险清单，交付更可控。'},
  {no: '03', title: '开发实施', description: '按迭代节奏推进研发、联调、测试和验收，持续可见。'},
  {no: '04', title: '交付运维', description: '上线后持续监控、优化和支持，让系统稳定运行。'}
]

const values = [
  {title: '技术创新', icon: 'fas fa-lightbulb'},
  {title: '专业服务', icon: 'fas fa-user-shield'},
  {title: '客户至上', icon: 'fas fa-handshake'},
  {title: '持续发展', icon: 'fas fa-chart-line'}
]

const advantages = [
  {
    title: 'App 开发',
    description: 'iOS、Android 原生应用与跨平台应用研发。',
    icon: 'fas fa-mobile-alt',
    items: ['原生应用开发', '应用商店发布']
  },
  {
    title: '小程序开发',
    description: '覆盖微信、支付宝、抖音等多平台小程序。',
    icon: 'fab fa-weixin',
    items: ['微信小程序', '支付宝小程序']
  },
  {
    title: '后端开发',
    description: '高性能、可扩展的后端系统开发与架构设计。',
    icon: 'fas fa-server',
    items: ['数据库设计', 'API 开发']
  },
  {
    title: '前端开发',
    description: '现代化前端工程体系，打造高质量用户体验。',
    icon: 'fas fa-code',
    items: ['响应式设计', '前端工程化', '性能优化']
  },
  {
    title: 'Web 应用开发',
    description: '面向企业业务场景的官网、系统和平台建设。',
    icon: 'fas fa-desktop',
    items: ['企业官网', '管理系统', '电商平台']
  },
  {
    title: '技术保障',
    description: '围绕安全、性能和稳定性的持续技术支持。',
    icon: 'fas fa-shield-alt',
    items: ['安全防护', '性能监控', '7x24 支持']
  }
]

const contactItems = [
  {label: '公司地址', value: '山东省菏泽市', icon: 'fas fa-map-marker-alt'},
  {label: '电子邮箱', value: '2036573698@qq.com', icon: 'fas fa-envelope'},
  {label: '工作时间', value: '周一至周五 9:00 - 18:00', icon: 'fas fa-clock'}
]

const leadForm = reactive({
  name: '',
  email: '',
  message: ''
})

const submitLead = () => {
  const subject = encodeURIComponent(`官网咨询 - ${leadForm.name || '访客'}`)
  const body = encodeURIComponent(`姓名：${leadForm.name}\n邮箱：${leadForm.email}\n需求：${leadForm.message}`)
  window.location.href = `mailto:2036573698@qq.com?subject=${subject}&body=${body}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createStaticVNode("<header class=\"site-nav\" data-v-0a3459f6><a class=\"brand\" href=\"#top\" aria-label=\"软创科技首页\" data-v-0a3459f6><img src=\"" + _imports_0 + "\" alt=\"软创科技\" data-v-0a3459f6></a><nav class=\"nav-links\" aria-label=\"主导航\" data-v-0a3459f6><a href=\"#services\" data-v-0a3459f6>核心服务</a><a href=\"#process\" data-v-0a3459f6>交付流程</a><a href=\"#advantages\" data-v-0a3459f6>技术优势</a><a href=\"#contact\" data-v-0a3459f6>联系我们</a></nav><a class=\"nav-cta\" href=\"#contact\" data-v-0a3459f6>启动项目</a></header>", 1)),
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("img", {
          class: "hero-bg",
          src: _unref(heroBg),
          alt: ""
        }, null, 8, _hoisted_3),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-overlay" }, null, -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-grid" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createStaticVNode("<p class=\"hero-kicker\" data-v-0a3459f6><span data-v-0a3459f6></span> 企业级技术研发 · 软件外包 · AI 落地 </p><h1 data-v-0a3459f6><span data-v-0a3459f6>软创科技</span><b data-v-0a3459f6>把复杂系统做成</b><em data-v-0a3459f6>增长引擎</em></h1><p class=\"hero-subtitle\" data-v-0a3459f6> 从需求洞察、架构设计到开发上线，我们用小而强的工程团队，为企业打造可增长、可迭代、可长期托付的数字化系统。 </p><div class=\"hero-actions\" data-v-0a3459f6><a class=\"primary-button\" href=\"#contact\" data-v-0a3459f6><i class=\"fas fa-bolt\" data-v-0a3459f6></i> 立即咨询 </a><a class=\"ghost-button\" href=\"#services\" data-v-0a3459f6> 查看服务 <i class=\"fas fa-arrow-right\" data-v-0a3459f6></i></a></div>", 4)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(heroProof, (item) => {
                return _createElementVNode("div", {
                  key: item.label
                }, [
                  _createElementVNode("strong", null, _toDisplayString(item.value), 1),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dashboard-header" }, [
              _createElementVNode("span", null, "Delivery Control"),
              _createElementVNode("strong", null, "LIVE")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (line) => {
                return _createElementVNode("span", {
                  key: line,
                  class: "signal-line"
                })
              }), 64)),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "signal-core" }, [
                _createElementVNode("div", { class: "signal-inner" }, [
                  _createElementVNode("span", null, "AI"),
                  _createElementVNode("em", null, "solution engine")
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dashboardMetrics, (item) => {
                return _createElementVNode("div", {
                  key: item.label
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.label), 1),
                  _createElementVNode("strong", null, _toDisplayString(item.value), 1)
                ])
              }), 64))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "code-window" }, [
              _createElementVNode("div", { class: "window-dots" }, [
                _createElementVNode("span"),
                _createElementVNode("span"),
                _createElementVNode("span")
              ]),
              _createElementVNode("pre", null, "deploy(\"vision\")\n  .strategy(\"fast-iterate\")\n  .secure()\n  .ship()")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(metrics, (metric) => {
            return _createElementVNode("article", {
              key: metric.label
            }, [
              _createElementVNode("strong", null, _toDisplayString(metric.value), 1),
              _createElementVNode("span", null, _toDisplayString(metric.label), 1)
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "section-heading" }, [
          _createElementVNode("p", null, "Build What Matters"),
          _createElementVNode("h2", null, "把想法压缩成可交付的产品战斗力"),
          _createElementVNode("span", null, " 聚焦技术自研、外包协作和定制化解决方案，用工程能力直接响应业务目标。 ")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (feature, index) => {
            return _createElementVNode("article", {
              key: feature.title,
              class: "service-card"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: feature.image,
                  alt: feature.title
                }, null, 8, _hoisted_15),
                _createElementVNode("span", null, _toDisplayString(index < 9 ? `0${index + 1}` : index + 1), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("i", {
                    class: _normalizeClass(feature.icon)
                  }, null, 2)
                ]),
                _createElementVNode("h3", null, _toDisplayString(feature.title), 1),
                _createElementVNode("p", null, _toDisplayString(feature.description), 1),
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", { key: tag }, _toDisplayString(tag), 1))
                  }), 128))
                ])
              ])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "section-heading compact" }, [
          _createElementVNode("p", null, "Execution Flow"),
          _createElementVNode("h2", null, "四段式交付，把风险前置，把结果做实")
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(processSteps, (step) => {
            return _createElementVNode("article", {
              key: step.title,
              class: "process-card"
            }, [
              _createElementVNode("span", null, _toDisplayString(step.no), 1),
              _createElementVNode("h3", null, _toDisplayString(step.title), 1),
              _createElementVNode("p", null, _toDisplayString(step.description), 1)
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("img", {
            src: _unref(aboutImg),
            alt: "软创科技团队工作场景"
          }, null, 8, _hoisted_23),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "about-caption" }, [
            _createElementVNode("strong", null, "菏泽 · 面向全国"),
            _createElementVNode("span", null, "敏捷协作，长期服务")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "eyebrow" }, "关于软创科技", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, "以工程确定性，支撑企业每一次关键升级", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("p", null, " 软创科技成立于 2025 年，专注为企业提供软件研发、系统集成、技术咨询与外包协作。我们相信好的官网不只展示形象，更应该清晰传达能力、效率与可信赖的交付方式。 ", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, " 团队覆盖前端、后端、移动端、数据与云服务能力，围绕业务目标拆解需求，用稳定架构和持续迭代帮助客户完成数字化转型。 ", -1)),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
              return _createElementVNode("div", {
                key: value.title
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(value.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(value.title), 1)
              ])
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_26, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "section-heading on-light" }, [
          _createElementVNode("p", null, "Tech Stack"),
          _createElementVNode("h2", null, "从 App 到云端，一套团队打穿完整链路"),
          _createElementVNode("span", null, "减少沟通损耗，让设计、开发、测试、部署和运维在同一个节奏里推进。")
        ], -1)),
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(advantages, (advantage) => {
            return _createElementVNode("article", {
              key: advantage.title,
              class: "advantage-card"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(advantage.icon)
              }, null, 2),
              _createElementVNode("h3", null, _toDisplayString(advantage.title), 1),
              _createElementVNode("p", null, _toDisplayString(advantage.description), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advantage.items, (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-check" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(item), 1)
                  ]))
                }), 128))
              ])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "eyebrow" }, "Start A Project", -1)),
          _cache[19] || (_cache[19] = _createElementVNode("h2", null, "给我们一个需求，换你一个可执行方案", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("p", null, " 说清目标、预算、周期或当前卡点即可。我们会基于业务场景给出技术路径、阶段拆解和交付建议。 ", -1)),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(contactItems, (item) => {
              return _createElementVNode("div", {
                key: item.label
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(item.label), 1),
                  _createTextVNode(" " + _toDisplayString(item.value), 1)
                ])
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("form", {
          class: "contact-form",
          onSubmit: _withModifiers(submitLead, ["prevent"])
        }, [
          _createElementVNode("label", null, [
            _cache[21] || (_cache[21] = _createTextVNode(" 姓名 ", -1)),
            _createVNode(_unref(ElInput), {
              modelValue: leadForm.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((leadForm.name) = $event)),
              placeholder: "请填写您的称呼"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", null, [
            _cache[22] || (_cache[22] = _createTextVNode(" 邮箱 ", -1)),
            _createVNode(_unref(ElInput), {
              modelValue: leadForm.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((leadForm.email) = $event)),
              placeholder: "用于接收方案回复"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", null, [
            _cache[23] || (_cache[23] = _createTextVNode(" 需求 ", -1)),
            _createVNode(_unref(ElInput), {
              modelValue: leadForm.message,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((leadForm.message) = $event)),
              type: "textarea",
              rows: 5,
              resize: "none",
              placeholder: "项目背景、目标、时间节点或需要解决的问题"
            }, null, 8, ["modelValue"])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("button", { type: "submit" }, [
            _createElementVNode("i", { class: "fas fa-paper-plane" }),
            _createTextVNode(" 发送需求 ")
          ], -1))
        ], 32)
      ])
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("footer", { class: "site-footer" }, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "软创科技"
        }),
        _createElementVNode("p", null, "技术研发与外包服务，助力企业创新发展。")
      ]),
      _createElementVNode("span", null, "© 2025 软创科技. 保留所有权利")
    ], -1))
  ]))
}
}

})